import React from 'react';
import { Pagination } from 'react-bootstrap';

const PaginationComponent = ({ 
    totalItems,
    itemsPerPage,
    currentPage,
    onPageChange,
    onItemsPerPageChange
}) => {
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    const maxVisiblePages = 5;

    const renderPaginationItems = () => {
        let items = [];

        // Add First and Prev buttons with symbols
        items.push(
            <Pagination.First key="<<" onClick={() => onPageChange(0)} disabled={currentPage === 0}>
                {"<<"}
            </Pagination.First>,
            <Pagination.Prev key="<" onClick={() => onPageChange(currentPage - 1)} disabled={currentPage === 0}>
                {"<"}
            </Pagination.Prev>
        );

        // Add page numbers
        for (let number = 0; number < totalPages; number++) {
            items.push(
                <Pagination.Item 
                    key={number} 
                    active={number === currentPage} 
                    onClick={() => onPageChange(number)}
                >
                    {number + 1}
                </Pagination.Item>
            );
        }

        // Add Next and Last buttons with symbols
        items.push(
            <Pagination.Next key=">" onClick={() => onPageChange(currentPage + 1)} disabled={currentPage === totalPages - 1}>
                {">"}
            </Pagination.Next>,
            <Pagination.Last key=">>" onClick={() => onPageChange(totalPages - 1)} disabled={currentPage === totalPages - 1}>
                {">>"}
            </Pagination.Last>
        );

        return items;
    };

    return (
        <div className="d-flex justify-content-between align-items-center">
            <Pagination>{renderPaginationItems()}</Pagination>
            <select 
                className="ms-3"
                value={itemsPerPage} 
                onChange={(e) => {
                    onItemsPerPageChange(Number(e.target.value));
                    onPageChange(0);
                }}
            >
                <option value={20}>20 per page</option>
                <option value={50}>50 per page</option>
                <option value={100}>100 per page</option>
            </select>
        </div>
    );
};

export default PaginationComponent;